/* eslint-disable no-useless-escape */
export const customScrollbar = {
  '&::-webkit-scrollbar': {
    width: '5px',
  },
  '&::-webkit-scrollbar-track': {
    width: '5px',
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#A0AEC0',
    borderRadius: '24px',
    '&:hover': {
      background: '#718096',
    },
  },
};

export const BASEURL = 'https://api.bolaodovanvan.com.br';